"use client";

import Image from "next/image";
import { useTheme } from "@/common/theme";

type Variant = "icon" | "wordmark" | "full";
type Size = "sm" | "md" | "lg";

const DIMENSIONS: Record<Variant, Record<Size, { w: number; h: number }>> = {
  icon: { sm: { w: 24, h: 24 }, md: { w: 32, h: 32 }, lg: { w: 48, h: 48 } },
  wordmark: { sm: { w: 96, h: 24 }, md: { w: 140, h: 32 }, lg: { w: 200, h: 48 } },
  full: { sm: { w: 80, h: 80 }, md: { w: 120, h: 120 }, lg: { w: 200, h: 200 } },
};

const SRC: Record<Variant, { light: string; dark: string }> = {
  icon: { light: "/brand/icon.png", dark: "/brand/icon-dark.png" },
  wordmark: { light: "/brand/wordmark.png", dark: "/brand/wordmark-dark.png" },
  full: { light: "/brand/logo-full.png", dark: "/brand/logo-full-dark.png" },
};

interface SPLogoProps {
  variant?: Variant;
  size?: Size;
  className?: string;
}

export function SPLogo({ variant = "icon", size = "md", className }: SPLogoProps) {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  const { w, h } = DIMENSIONS[variant][size];
  const src = isDark ? SRC[variant].dark : SRC[variant].light;
  return (
    <Image
      src={src}
      alt="Structura Pro"
      width={w}
      height={h}
      className={className}
      priority
    />
  );
}
